import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-disease-list',
  templateUrl: './disease-list.component.html',
  styleUrls: ['./disease-list.component.scss']
})
export class DiseaseListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
